import * as React from 'react';
import DataCrafterAppOutputPreviewScreen from '../screens/DataCrafterAppOutputPreviewScreen/DataCrafterAppOutputPreviewScreen';
import { Route } from 'react-router';

const dataCrafterAppPreviewRoute = () => {
    return <Route path={'/data-crafter/preview/:sessionId'} element={<DataCrafterAppOutputPreviewScreen />} />;
};

export default dataCrafterAppPreviewRoute;
